export const LEFT_LAYOUT = 'Left Layout';
export const RIGHT_LAYOUT = 'Right Layout';
export const DEFAULT_IMG_ALT = 'Uploaded Image';
export const VIDEO = 'discovery_video';
export const ARTICLE = 'discovery_article';
